import colors from "vuetify/lib/util/colors";

// we can make changes the the colours here

export default colors;
